export default __webpack_public_path__ + "static/media/thumbnail.b77bc271.png";